export const memberOf = <T>(element: T, arr: T[]) => arr.indexOf(element) !== -1;
